/**
 * @generated SignedSource<<d5b03874966b4340c0d326362bdaa611>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationFlourishDeleteMutation$variables = Record<PropertyKey, never>;
export type IntegrationFlourishDeleteMutation$data = {
  readonly store: {
    readonly deleteIntegrationFlourish: boolean | null;
  };
};
export type IntegrationFlourishDeleteMutation = {
  response: IntegrationFlourishDeleteMutation$data;
  variables: IntegrationFlourishDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleteIntegrationFlourish",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationFlourishDeleteMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "IntegrationFlourishDeleteMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "9e721ad4645a9c94a0e46fcb38db63e0",
    "id": null,
    "metadata": {},
    "name": "IntegrationFlourishDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationFlourishDeleteMutation {\n  store {\n    deleteIntegrationFlourish\n  }\n}\n"
  }
};
})();

(node as any).hash = "87aede1c56d262da41723e3a28ac5f4c";

export default node;
